import { render, staticRenderFns } from "./serviceFee.vue?vue&type=template&id=650b0f02&scoped=true"
import script from "./serviceFee.vue?vue&type=script&lang=js"
export * from "./serviceFee.vue?vue&type=script&lang=js"
import style0 from "./serviceFee.vue?vue&type=style&index=0&id=650b0f02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650b0f02",
  null
  
)

export default component.exports